import * as React from 'react';

export function SvgAddClip(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 20C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V12C20 12.5523 20.4477 13 21 13C21.5523 13 22 12.5523 22 12V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H12C12.5523 22 13 21.5523 13 21C13 20.4477 12.5523 20 12 20H5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 22C7.55228 22 8 21.5523 8 21V3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3V21C6 21.5523 6.44772 22 7 22Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 16.5C2 17.0523 2.44772 17.5 3 17.5H7C7.55228 17.5 8 17.0523 8 16.5C8 15.9477 7.55228 15.5 7 15.5H3C2.44772 15.5 2 15.9477 2 16.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 12.5523 2.44772 13 3 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H3C2.44772 11 2 11.4477 2 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 7.5C2 8.05228 2.44772 8.5 3 8.5H7C7.55228 8.5 8 8.05228 8 7.5C8 6.94772 7.55228 6.5 7 6.5H3C2.44772 6.5 2 6.94772 2 7.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 13C17.5523 13 18 12.5523 18 12L18 3C18 2.44771 17.5523 2 17 2C16.4477 2 16 2.44771 16 3L16 12C16 12.5523 16.4477 13 17 13Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 7.5C16 8.05228 16.4477 8.5 17 8.5H21C21.5523 8.5 22 8.05228 22 7.5C22 6.94772 21.5523 6.5 21 6.5H17C16.4477 6.5 16 6.94772 16 7.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 22C18.5523 22 19 21.5523 19 21V15C19 14.4477 18.5523 14 18 14C17.4477 14 17 14.4477 17 15V21C17 21.5523 17.4477 22 18 22Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 18C22 17.4477 21.5523 17 21 17L15 17C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19L21 19C21.5523 19 22 18.5523 22 18Z"
        fill="currentColor"
      />
    </svg>
  );
}
